<template>
    <BusinessCard />
</template>

<script>
import BusinessCard from "./components/BusinessCard.vue";

export default {
  name: "App",
  components: {
    BusinessCard,
  },
};
</script>